export default __webpack_public_path__ + "static/media/visuals-placeholder.6d50bec3.png";